import { connect } from 'react-redux'

import ProfileAccountForm from 'app/session/bc_profile/account_container'

export default connect()(ProfileAccountForm)
